import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";
import {
  deletePhotoAttachmentService,
  getPortfolioPhotoAttachmentsService,
} from "../../services/photoBook";
import {
  useDataQuery,
  // useDataQueryClient,
} from "@Libs/DataLayer/hooks/useDataQuery";
import { PORTFOLIO_QUERY_KEY } from "./usePhotoBookUpload";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { useEffect, useState } from "react";
import { IPhoto } from "@modules/ServiceProviders/Containers/PhotoBookRouter/Router";

export const usePhotoBook = () => {
  //const queryClient = useDataQueryClient();

  const [photoPreview, setPhotoPreview] = useState<IPhoto[]>([]);
  const [portfolioData, setPortfolioData] = useState<{
    photos: IPhoto[];
    count?: number;
  }>({ photos: [] });
  const [pagination, setPagination] = useState({ limit: 20, offset: 0 });

  const { currentUser } = useCurrentUser({ includes: ["serviceProvider"] });

  const incrementPagination = () =>
    setPagination((prev) => ({
      ...prev,
      offset: prev.limit + prev.offset,
    }));

  const {
    isLoading: isLoadingPortfolio,
    isFetching: isFetchingPortfolio,
    refetch: getMorePortfolioPhoto,
  } = useDataQuery(
    [PORTFOLIO_QUERY_KEY, currentUser?.id],
    () =>
      getPortfolioPhotoAttachmentsService({
        listworker_id: currentUser?.serviceProvider?.id,
        limit: pagination.limit,
        offset: pagination.offset,
      }),
    {
      onSuccess: (data) => {
        setPortfolioData({ photos: data?.photos, count: data?.count });
        photoPreview?.length < data.count && incrementPagination();
      },
      enabled: false,
      retry: 2,
    }
  );

  useEffect(() => {
    currentUser && getMorePortfolioPhoto();
  }, [currentUser]);

  const portfolioPhotoTotalCount = portfolioData?.count;
  const portfolioPhoto = portfolioData?.photos || [];

  const {
    isLoading: isDeleting,
    isSuccess: hasDeletedSuccessfully,
    isError: isErrorDeleting,
    mutate: deletePhotoAttachment,
  } = useDataMutation(
    (photoAttachmentIds: string[] | number[]) => {
      const promises = photoAttachmentIds.map((id) =>
        deletePhotoAttachmentService(id)
      );
      return Promise.all(promises);
    },
    {
      onSuccess: (_, variables) => {
        // just doing this to update the count without requesting another api
        setPortfolioData((prev) => ({
          photos: [],
          count: prev.count - variables.length,
        }));
      },
    }
  );

  return {
    photoPreview,
    setPhotoPreview,
    isDeleting,
    hasDeletedSuccessfully,
    isErrorDeleting,
    deletePhotoAttachment,
    isLoadingPortfolio,
    isFetchingPortfolio,
    portfolioPhoto,
    portfolioPhotoTotalCount,
    getMorePortfolioPhoto,
    incrementPagination,
  };
};
